<div class="At-SettingsContent">
  <div class="At-InformationBox">
    <div class="At-Title">
      <h3>Privacy</h3>
    </div>
    <ul class="At-InformationList">
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Profile Photo</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">My Contacts</button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Last Seen</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">My Contacts</button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Calls</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">Everybody</button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Messages</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">Everybody</button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Posts</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">Everybody</button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Photos & Videos</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">My Contacts</button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Location</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">My Contacts</button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Phone Number</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">My Contacts</button>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Contact List</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">Nobody</button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div class="At-InformationBox">
    <div class="At-Title">
      <h3>Security</h3>
    </div>
    <ul class="At-InformationList">
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleLeft">
              <h5>Password</h5>
            </div>
            <div class="At-TitleRight">
              <button type="button">Change</button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div class="At-InformationBox">
    <div class="At-Title">
      <h3>Account</h3>
    </div>
    <ul class="At-InformationList">
      <li>
        <div class="At-InfoBox">
          <div class="At-InfoTitle d-flex">
            <div class="At-TitleRight">
              <button type="button" class="At-TextRed">Delete Account</button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
